import Vue from 'vue';

export default (id, params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`subscriberList/rules/${id}`, params)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriberList/storeRules.js